export default __webpack_public_path__ + "static/logo-66df0ba20bfd2776274d23c26f010b55.png";